"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.FinStatementCsvLineItemArraySchema = exports.DatabaseSchema = exports.DataSourceSchema = exports.StatementBasisSchema = exports.SectionSchema = exports.IncomeStatementSectionSchema = exports.BalanceSheetSectionSchema = exports.StatementSchema = exports.ReportFrequencySchema = void 0;
const Bank_1 = require("./Bank");
const Utils_1 = require("./Utils");
const v4_1 = require("zod/v4");
/**
 * BASE TYPES
 */
exports.ReportFrequencySchema = v4_1.z.enum(['month', 'quarter', 'year']);
exports.StatementSchema = v4_1.z.enum(['balanceSheet', 'incomeStatement']);
exports.BalanceSheetSectionSchema = v4_1.z.enum([
    'assets',
    'liabilities',
    'equity',
]);
exports.IncomeStatementSectionSchema = v4_1.z.enum(['income', 'expenses']);
exports.SectionSchema = v4_1.z.union([
    exports.BalanceSheetSectionSchema,
    exports.IncomeStatementSectionSchema,
]);
exports.StatementBasisSchema = v4_1.z.enum(['plan', 'actual']);
exports.DataSourceSchema = v4_1.z.enum(['dataPipeline', 'railz']);
/**
 * TABLE SCHEMA
 */
exports.DatabaseSchema = v4_1.z.enum(['pg', 's3']);
const FinStatementRecordSchema = v4_1.z.object({
    id: v4_1.z.string(),
    organizationId: v4_1.z.string(),
    endOfPeriodDate: Utils_1.ZodFullDateStrStruct,
    version: v4_1.z.int(),
    statement: exports.StatementSchema,
    reportFrequency: exports.ReportFrequencySchema,
    currency: Bank_1.CurrencyCodeSchema,
    basis: exports.StatementBasisSchema,
    dataSource: exports.DataSourceSchema,
    rawSourceDb: exports.DatabaseSchema.nullable(),
    rawSourceNamespace: v4_1.z.string().nullable(),
    rawSourceIdentifier: v4_1.z.string().nullable(),
    markupS3Bucket: v4_1.z.string().nullable(),
    markupS3Key: v4_1.z.string().nullable(),
});
const FinStatementLineItemSchema = v4_1.z.object({
    section: exports.SectionSchema,
    ledgerName: v4_1.z.string(),
    value: v4_1.z.number(),
    groups: v4_1.z.array(v4_1.z.string()),
});
const FinStatementCsvLineItemSchema = FinStatementLineItemSchema.omit({
    groups: true,
}).extend({ groups: v4_1.z.string().nullable().optional().default('') }); // groups is a pipe | delimited string
exports.FinStatementCsvLineItemArraySchema = v4_1.z.array(FinStatementCsvLineItemSchema);
const FinStatementLineItemRecordSchema = FinStatementLineItemSchema.extend({
    id: v4_1.z.string(),
    finStatementId: v4_1.z.string(),
});
const FinStatementSchema = FinStatementRecordSchema.extend({
    lineItems: v4_1.z.array(FinStatementLineItemRecordSchema),
});
//# sourceMappingURL=FinStatementsV2.js.map